import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ChartModule } from 'primeng/chart';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';         // PrimeNG table
import { DropdownModule } from 'primeng/dropdown';
import { TreeModule } from 'primeng/tree';
import { ListboxModule } from 'primeng/listbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BoardComponent } from './board.component';
import { BoardHomeComponent } from './pages/board-home/board-home.component';
import { FilesComponent } from './pages/files/files.component';
import { AboutComponent } from './pages/about/about.component';
import { HelpComponent } from './pages/help/help.component';
import { DataEntryComponent } from './pages/data-entry/data-entry.component';
import { BhubSidebarComponent } from './bhub-sidebar/bhub-sidebar.component';
import { BhubPageHolderComponent } from './bhub-page-holder/bhub-page-holder.component';
import { HeroTileComponent } from './pages/board-home/board-tiles/hero-tile/hero-tile.component';
import { BoardItemCreatorComponent } from './pages/board-home/board-item-creator/board-item-creator.component';
import { TileMetricPickerComponent } from './pages/board-home/board-tiles/tile-metric-picker/tile-metric-picker.component';
import { TableTileComponent } from './pages/board-home/board-tiles/table-tile/table-tile.component';
import { ChartTileComponent } from './pages/board-home/board-tiles/chart-tile/chart-tile.component';
import { PieTileComponent } from './pages/board-home/board-tiles/pie-tile/pie-tile.component';
import { ViewBoardsComponent } from './pages/board-home/view-boards/view-boards.component';
import { ManageBoardsComponent } from './pages/board-home/manage-boards/manage-boards.component';
import { MyTablesPageModule } from './pages/my-tables/my-tables-page.module';

import { BoardRoutingModule } from './board-routing.module';
import { BhubCommonModule } from '../common/bhub-common-module/bhub-common.module';

import { GridsterModule } from 'angular-gridster2';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromBoardState from './+store/board-state/board-state.reducer';
import { BoardStateEffects } from './+store/board-state/board-state.effects';
import { BoardStateService } from './+store/board-state/board-state-services/board-state.service';
import { BoardTypeSelectorComponent } from './pages/board-home/board-types/board-type-selector/board-type-selector.component';
import { TileBoardEditorComponent } from './pages/board-home/board-types/tile-board/tile-board-editor.component';
import { SpreadsheetBoardEditorComponent } from './pages/board-home/board-types/spreadsheet-board/spreadsheet-board-editor.component';
import { TileBoardViewerComponent } from './pages/board-home/board-types/tile-board-viewer/tile-board-viewer.component';
import { SpreadsheetBoardViewerComponent } from './pages/board-home/board-types/spreadsheet-board-viewer/spreadsheet-board-viewer.component';
import { SpreadsheetGridComponent } from './pages/board-home/board-types/spreadsheet-board/spreadsheet-grid/spreadsheet-grid.component';
import { CellContentEditorComponent } from './pages/board-home/board-types/spreadsheet-board/cell-content-editor/cell-content-editor.component';
import { TextInputModalComponent } from './pages/board-home/board-types/spreadsheet-board/text-input-modal/text-input-modal.component';
import { MetricInputModalComponent } from './pages/board-home/board-types/spreadsheet-board/metric-input-modal/metric-input-modal.component';
import { TableSelectionModalComponent } from './pages/board-home/board-types/spreadsheet-board/table-selection-modal/table-selection-modal.component';
import { CustomViewsComponent } from './pages/custom-views/custom-views.component';
import { FolderSelectDialogComponent } from './pages/files/folder-select-dialog/folder-select-dialog.component';
// CustomViewRendererModule removed - using BhubCommonModule instead

/**
 * This Module houses the board that users will see upon entering the application. It will contain a navigation pane at the top
 * and house the content of the application via a series of pages.
 */
@NgModule({
  declarations: [
    BoardComponent,
    BoardHomeComponent,
    ViewBoardsComponent,
    ManageBoardsComponent,
    FilesComponent,
    DataEntryComponent,
    AboutComponent,
    HelpComponent,
    BhubSidebarComponent,
    BhubPageHolderComponent,
    HeroTileComponent,
    BoardItemCreatorComponent,
    TileMetricPickerComponent,
    TableTileComponent,
    ChartTileComponent,
    PieTileComponent,
    BoardTypeSelectorComponent,
    TileBoardEditorComponent,
    SpreadsheetBoardEditorComponent,
    TileBoardViewerComponent,
    SpreadsheetBoardViewerComponent,
    SpreadsheetGridComponent,
    CellContentEditorComponent,
    TextInputModalComponent,
    MetricInputModalComponent,
    TableSelectionModalComponent,
    CustomViewsComponent,
    FolderSelectDialogComponent
  ],
  imports: [
    BoardRoutingModule,
    CommonModule,
    BhubCommonModule,
    MyTablesPageModule,
    // Using BhubCommonModule which now includes cell components
    MatIconModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatToolbarModule,
    MatTabsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    GridsterModule,
    TableModule,
    DropdownModule,
    TreeModule, //primeNg tree
    ChartModule, //primeNg chart
    ListboxModule,
    MatOptionModule,
    ButtonModule,
    InputTextModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTooltipModule,
    StoreModule.forFeature(fromBoardState.boardStateFeatureKey, fromBoardState.reducer),
    EffectsModule.forFeature([BoardStateEffects]),
  ],
  providers: [
    BoardStateService
  ],
  exports: [
    BoardComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class BoardModule { }
